import fetchActivityLogs from './componentWillMount'

export default (pagination) => (dispatch) => {
  dispatch(fetchActivityLogs(pagination.current, pagination.pageSize))
}
